export default "__VITE_ASSET__c80e5eca__"